document.addEventListener("DOMContentLoaded", function() {
  const countryList = jQuery('#country-list')
  if (countryList.length > 0) {
    function countryTemplate(item) {
      return `<li class="disclosure__item"> <a href="#" class="disclosure__link" data-value="${item.iso}">${item.name}</a></li>`
    }

    let europe = '';
    let asia = '';
    let america = '';
    let africa = '';
    let oceania = '';

    for (const country in geoCountryMap) {
      let item = geoCountryMap[country]
      if (availableCountries.includes(item.iso)) {
        switch (item.continent) {
          case 'europe':
            europe += countryTemplate(item)
            break;
          case 'asia':
            asia += countryTemplate(item)
            break;
          case 'north america':
            america += countryTemplate(item)
            break;
          case 'south america':
            america += countryTemplate(item)
            break;
          case 'africa':
            africa += countryTemplate(item)
            break;
          default:
            oceania += countryTemplate(item)
            break;
        }
      }
    }

    jQuery('.europe-list').append(europe);
    jQuery('.asia-list').append(asia);
    jQuery('.america-list').append(america);
    jQuery('.africa-list').append(africa);
    jQuery('.oceania-list').append(oceania);

    $(document).on('click', '.disclosure__link', function(e) {
      e.preventDefault()
      let code = e.target.dataset.value
      jQuery('.country-list-form .country_code').val(code)
      jQuery('.country-list-form').submit()
    })
  }
});
